import React from "react";
import { spring, useVideoConfig } from "remotion";
import { BulletItem } from "../../types";
import { CompanyBadge } from "../../components/CompanyBadge";
import { detectBrandInText } from "../../components/companyDetector";

interface PrismInsightsProps {
  bullets: BulletItem[];
  globalFrame: number;
}

export const PrismInsights: React.FC<PrismInsightsProps> = ({
  bullets,
  globalFrame,
}) => {
  const { fps } = useVideoConfig();

  return (
    <div
      style={{
        flex: 1,
        padding: "0 50px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      {bullets.map((bullet, index) => {
        const startFrame = (bullet.startMs / 1000) * fps;
        const relativeFrame = globalFrame - startFrame;

        const opacity = spring({
          frame: relativeFrame,
          fps,
          from: 0,
          to: 1,
          config: { damping: 20 },
        });

        const slide = spring({
          frame: relativeFrame,
          fps,
          from: 20,
          to: 0,
          config: { damping: 15, mass: 0.8 },
        });

        const isActive = globalFrame >= startFrame && globalFrame <= (bullet.endMs / 1000) * fps;

        return (
          <div
            key={index}
            style={{
              opacity,
              transform: `translateY(${slide}px)`,
              background: isActive ? "rgba(255, 255, 255, 0.6)" : "transparent",
              backdropFilter: isActive ? "blur(10px)" : "none",
              WebkitBackdropFilter: isActive ? "blur(10px)" : "none",
              borderLeft: isActive ? "3px solid #b388ff" : "3px solid transparent",
              padding: "20px 24px",
              borderRadius: "0 16px 16px 0",
              transition: "all 0.3s ease",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <p
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: "28px",
                fontWeight: 600,
                color: "#1a1a1a",
                lineHeight: 1.4,
                margin: 0,
                flex: 1,
              }}
            >
              {bullet.text}
            </p>
            {isActive && (() => {
              const brand = detectBrandInText(bullet.text);
              return brand ? (
                <CompanyBadge
                  name={brand}
                  color="#b388ff"
                  accentColor="#b388ff"
                  size={50}
                  style="glass"
                  opacity={opacity}
                />
              ) : null;
            })()}
          </div>
        );
      })}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
